import React, { useState, useEffect } from 'react';
import { auth, db, googleProvider } from '../firebase';
import { doc, getDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { EmailAuthProvider, reauthenticateWithCredential, reauthenticateWithPopup, deleteUser } from 'firebase/auth';
import { useGyerekek, jelvenyekSzamitasa } from '../GyerekekContext';

const KOROSZTALYOK_VALTAS = [
  { ertek: '6-8', cimke: '6–8 év' },
  { ertek: '9-11', cimke: '9–11 év' },
  { ertek: '12-14', cimke: '12–14 év' },
];

const AVATAR_SZINEK = [
  { szin1: '#1a73e8', szin2: '#9c27b0' },
  { szin1: '#34a853', szin2: '#00bcd4' },
  { szin1: '#f9ab00', szin2: '#ff6d00' },
  { szin1: '#ea4335', szin2: '#f06292' },
  { szin1: '#7c3aed', szin2: '#a78bfa' },
  { szin1: '#0d7377', szin2: '#14ffec' },
];
const AVATAR_IKONOK = ['🤖', '🦸', '🐱', '🦊', '🐧', '🚀', '🌟', '🎮', '🦄', '🐼'];

// Kis, újrahasznált avatár-szerkesztő panel (szín + ikon választás) — csak a
// gyerek-profilokhoz használjuk, a szülő saját avatárja nem szerkeszthető.
function AvatarSzerkeszto({ avatar, onValtozas, onMentes, mentve }) {
  return (
    <div style={{
      background: 'var(--bg-card-alt)', borderRadius: '18px', padding: '1.25rem',
      border: '2px solid var(--border-color)', marginTop: '1rem',
    }}>
      <div style={{fontSize: '13px', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '8px'}}>Szín</div>
      <div style={{display: 'flex', gap: '8px', marginBottom: '1rem', flexWrap: 'wrap'}}>
        {AVATAR_SZINEK.map((sz, i) => (
          <button key={i} type="button" onClick={() => onValtozas({ ...avatar, szin1: sz.szin1, szin2: sz.szin2 })}
            style={{
              width: '36px', height: '36px', borderRadius: '50%', cursor: 'pointer',
              background: `linear-gradient(135deg, ${sz.szin1}, ${sz.szin2})`,
              border: avatar.szin1 === sz.szin1 ? '3px solid #1a1a2e' : '3px solid transparent',
            }} />
        ))}
      </div>
      <div style={{fontSize: '13px', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '8px'}}>Karakter</div>
      <div style={{display: 'flex', gap: '8px', marginBottom: '1.25rem', flexWrap: 'wrap'}}>
        {AVATAR_IKONOK.map((ik, i) => (
          <button key={i} type="button" onClick={() => onValtozas({ ...avatar, ikon: ik })}
            style={{
              width: '40px', height: '40px', borderRadius: '12px', fontSize: '20px', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: avatar.ikon === ik ? '#e3f2fd' : 'white',
              border: avatar.ikon === ik ? '2px solid #1a73e8' : '2px solid var(--border-color-strong)',
            }}>
            {ik}
          </button>
        ))}
      </div>
      <button onClick={onMentes} disabled={mentve}
        style={{
          padding: '10px 24px', borderRadius: '50px', border: 'none', fontSize: '14px', fontWeight: 800,
          color: 'white', cursor: 'pointer', background: 'linear-gradient(135deg, #1a73e8, #4fc3f7)',
          opacity: mentve ? 0.6 : 1,
        }}>
        {mentve ? '✅ Mentve!' : 'Mentés'}
      </button>
    </div>
  );
}

function ProfilOldal({ felhasznalo }) {
  const { gyerekek, gyerekekFrissitese } = useGyerekek();

  // Gyerek-profil szerkesztés (a "⋯" menüből nyitva)
  const [nyitottMenuGyerekId, setNyitottMenuGyerekId] = useState(null);
  const [szerkesztettGyerekId, setSzerkesztettGyerekId] = useState(null); // melyik gyereknél van nyitva a "Módosítás" panel
  const [karakterSzerkesztesGyerekId, setKarakterSzerkesztesGyerekId] = useState(null);
  const [nevSzerkesztesGyerekId, setNevSzerkesztesGyerekId] = useState(null);
  const [nevSzerkesztesErtek, setNevSzerkesztesErtek] = useState('');
  const [nevMentesFolyamatban, setNevMentesFolyamatban] = useState(false);
  const [gyerekMentve, setGyerekMentve] = useState(false);
  const [torlesMegerosites, setTorlesMegerosites] = useState(null); // gyerekId, akinek a törlését megerősítjük

  const [koroszalyValtasGyerekId, setKoroszalyValtasGyerekId] = useState(null);
  const [megerositendoKoroszaly, setMegerositendoKoroszaly] = useState(null); // { gyerekId, uj }
  const [jelszoBekero, setJelszoBekero] = useState(false);
  const [jelszoMezo, setJelszoMezo] = useState('');
  const [valtasHiba, setValtasHiba] = useState('');
  const [valtasFolyamatban, setValtasFolyamatban] = useState(false);

  // Új gyermek hozzáadása
  const [ujGyerekFormaNyitva, setUjGyerekFormaNyitva] = useState(false);
  const [ujGyerekNev, setUjGyerekNev] = useState('');
  const [ujGyerekKor, setUjGyerekKor] = useState('6-8');
  const [ujGyerekMentesFolyamatban, setUjGyerekMentesFolyamatban] = useState(false);

  // Fiók végleges törlése
  const [fiokTorlesNyitva, setFiokTorlesNyitva] = useState(false);
  const [fiokTorlesJelszoBekero, setFiokTorlesJelszoBekero] = useState(false);
  const [fiokTorlesJelszo, setFiokTorlesJelszo] = useState('');
  const [fiokTorlesHiba, setFiokTorlesHiba] = useState('');
  const [fiokTorlesFolyamatban, setFiokTorlesFolyamatban] = useState(false);

  const gyerekAvatarMentese = async (gyerekId, ujAvatar) => {
    const ujLista = gyerekek.map(gy => gy.id === gyerekId ? { ...gy, avatar: ujAvatar } : gy);
    setGyerekMentve(true);
    await gyerekekFrissitese(ujLista);
    setTimeout(() => setGyerekMentve(false), 1500);
  };

  const gyerekAvatarValtozas = (gyerekId, ujAvatar) => {
    gyerekekFrissitese(gyerekek.map(gy => gy.id === gyerekId ? { ...gy, avatar: ujAvatar } : gy));
  };

  // Gyerek nevének módosítása.
  const gyerekNevMentese = async (gyerekId) => {
    if (!nevSzerkesztesErtek.trim()) return;
    setNevMentesFolyamatban(true);
    const ujLista = gyerekek.map(gy => gy.id === gyerekId ? { ...gy, nev: nevSzerkesztesErtek.trim() } : gy);
    await gyerekekFrissitese(ujLista);
    setNevMentesFolyamatban(false);
    setNevSzerkesztesGyerekId(null);
  };

  // Új gyermek-profil hozzáadása közvetlenül a Profil oldalról.
  const ujGyerekMentese = async () => {
    if (!ujGyerekNev.trim()) return;
    setUjGyerekMentesFolyamatban(true);
    const ujGyerek = {
      id: crypto.randomUUID(),
      nev: ujGyerekNev.trim(),
      koroszaly: ujGyerekKor,
      xp: 0,
      letrehozva: new Date().toISOString(),
    };
    await gyerekekFrissitese([...gyerekek, ujGyerek]);
    setUjGyerekNev('');
    setUjGyerekKor('6-8');
    setUjGyerekFormaNyitva(false);
    setUjGyerekMentesFolyamatban(false);
  };

  // Egy gyermek-profil végleges törlése (megerősítés után).
  const gyerekTorlese = async (gyerekId) => {
    const ujLista = gyerekek.filter(gy => gy.id !== gyerekId);
    await gyerekekFrissitese(ujLista);
    setTorlesMegerosites(null);
    if (szerkesztettGyerekId === gyerekId) setSzerkesztettGyerekId(null);
    if (koroszalyValtasGyerekId === gyerekId) setKoroszalyValtasGyerekId(null);
  };

  // Korosztály váltás: kiválasztás → megerősítés kérése → hitelesítés (Google
  // fióknál Google-jal, jelszavas fióknál a fiók jelszavával) → csak utána mentés.
  const koroszalyValtasKezdemenyezese = (gyerekId, ujKoroszaly, aktualisKoroszaly) => {
    if (ujKoroszaly === aktualisKoroszaly) return;
    setMegerositendoKoroszaly({ gyerekId, uj: ujKoroszaly });
    setValtasHiba('');
    setJelszoBekero(false);
    setJelszoMezo('');
  };

  const koroszalyValtasVegrehajtasa = async (celGyerekId, ujKoroszaly) => {
    const ujLista = gyerekek.map(gy => gy.id === celGyerekId ? { ...gy, koroszaly: ujKoroszaly } : gy);
    await gyerekekFrissitese(ujLista);
    setMegerositendoKoroszaly(null);
    setJelszoBekero(false);
    setJelszoMezo('');
    setValtasFolyamatban(false);
    setKoroszalyValtasGyerekId(null);
  };

  const koroszalyValtasMegerositese = async () => {
    if (!megerositendoKoroszaly) return;
    setValtasHiba('');
    const googleFiok = felhasznalo?.providerData?.some(p => p.providerId === 'google.com');
    setValtasFolyamatban(true);
    try {
      if (googleFiok) {
        await reauthenticateWithPopup(auth.currentUser, googleProvider);
        await koroszalyValtasVegrehajtasa(megerositendoKoroszaly.gyerekId, megerositendoKoroszaly.uj);
      } else {
        setJelszoBekero(true);
        setValtasFolyamatban(false);
      }
    } catch (err) {
      setValtasHiba('A hitelesítés sikertelen volt. Próbáld újra!');
      setValtasFolyamatban(false);
    }
  };

  const jelszavasMegerositesKuldese = async () => {
    if (!jelszoMezo || !megerositendoKoroszaly) return;
    setValtasFolyamatban(true);
    setValtasHiba('');
    try {
      const credential = EmailAuthProvider.credential(felhasznalo.email, jelszoMezo);
      await reauthenticateWithCredential(auth.currentUser, credential);
      await koroszalyValtasVegrehajtasa(megerositendoKoroszaly.gyerekId, megerositendoKoroszaly.uj);
    } catch (err) {
      setValtasHiba('Helytelen jelszó!');
      setValtasFolyamatban(false);
    }
  };

  const koroszalyValtasMegse = () => {
    setMegerositendoKoroszaly(null);
    setJelszoBekero(false);
    setJelszoMezo('');
    setValtasHiba('');
  };

  // Fiók végleges törlése: megerősítés → hitelesítés (Google-nál popup,
  // jelszavas fióknál a jelszó) → a Firestore-dokumentum ÉS a Firebase-fiók
  // végleges törlése. Sikeres törlés után a bejelentkezési állapot
  // automatikusan null-ra vált (App.js onAuthStateChanged), a védett
  // útvonal pedig kiléptet a bejelentkezés oldalra.
  const fiokVeglegesTorlesVegrehajtasa = async () => {
    try {
      await deleteDoc(doc(db, 'felhasznalok', felhasznalo.uid));
    } catch (err) {
      // ha a dokumentum már nem létezik, nem probléma — folytatjuk a fiók törlésével
    }
    await deleteUser(auth.currentUser);
  };

  const fiokTorlesMegerositese = async () => {
    setFiokTorlesHiba('');
    const googleFiok = felhasznalo?.providerData?.some(p => p.providerId === 'google.com');
    setFiokTorlesFolyamatban(true);
    try {
      if (googleFiok) {
        await reauthenticateWithPopup(auth.currentUser, googleProvider);
        await fiokVeglegesTorlesVegrehajtasa();
      } else {
        setFiokTorlesJelszoBekero(true);
        setFiokTorlesFolyamatban(false);
      }
    } catch (err) {
      setFiokTorlesHiba('A hitelesítés sikertelen volt. Próbáld újra!');
      setFiokTorlesFolyamatban(false);
    }
  };

  const fiokTorlesVegrehajtasaJelszoval = async () => {
    if (!fiokTorlesJelszo) return;
    setFiokTorlesFolyamatban(true);
    setFiokTorlesHiba('');
    try {
      const credential = EmailAuthProvider.credential(felhasznalo.email, fiokTorlesJelszo);
      await reauthenticateWithCredential(auth.currentUser, credential);
      await fiokVeglegesTorlesVegrehajtasa();
    } catch (err) {
      setFiokTorlesHiba('Helytelen jelszó!');
      setFiokTorlesFolyamatban(false);
    }
  };

  const fiokTorlesMegse = () => {
    setFiokTorlesNyitva(false);
    setFiokTorlesJelszoBekero(false);
    setFiokTorlesJelszo('');
    setFiokTorlesHiba('');
  };

  const aktivGyerek = gyerekek[0] || null;
  const xp = aktivGyerek?.xp || 0;
  const szint = Math.floor(xp / 100) + 1;
  const kovetkezoSzintXP = szint * 100;
  const szintSzazalek = Math.round((xp % 100));

  // A gyerek modulonkénti haladása (a GyerekekContext haladasMentese
  // függvénye tölti fel) — innen számoljuk a teljesített leckék számát a
  // statisztika-kártyához. A jelvények listáját a közös jelvenyekSzamitasa
  // függvény adja (ugyanazt használja a GyerekekContext is, amikor eldönti,
  // hogy felugorjon-e a jelvény-ablak).
  const halado = aktivGyerek?.halado || {};
  const teljesitettLeckek = (halado['6-8'] || []).length + (halado['9-11'] || []).length + (halado['12-14'] || []).length;
  const jelvények = jelvenyekSzamitasa(aktivGyerek);

  return (
    <>
     <style>{`
        .profil {
          min-height: calc(100vh - 70px);
          background: var(--bg-page);
          padding: 4rem 2rem;
          box-sizing: border-box;
        }
        .profil-inner {
          max-width: 900px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          gap: 2rem;
        }
        .profil-fejlec {
          background: var(--bg-card);
          border-radius: 28px;
          padding: 2.5rem;
          box-shadow: 0 4px 20px rgba(0,0,0,0.06);
          border: 2px solid var(--border-color);
          display: flex;
          align-items: center;
          gap: 2rem;
          flex-wrap: wrap;
        }
        .profil-avatar-keret { position: relative; flex-shrink: 0; }
        .profil-avatar {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background: linear-gradient(135deg, #1a73e8, #9c27b0);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 48px;
          box-shadow: 0 8px 24px rgba(26,115,232,0.3);
        }
        .profil-info { flex: 1; min-width: 200px; }
        .profil-nev-sor { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 6px; }
        .profil-nev {
          font-size: 28px;
          font-weight: 900;
          color: var(--text-primary);
        }
        .profil-szulo-badge {
          background: #e3f2fd;
          color: #1a73e8;
          font-size: 12px;
          font-weight: 800;
          padding: 5px 14px;
          border-radius: 50px;
          border: 1.5px solid #1a73e8;
          white-space: nowrap;
        }
        .profil-email {
          font-size: 14px;
          color: var(--text-muted);
          font-weight: 600;
          margin-bottom: 1rem;
        }
        .profil-szint-sor {
          display: flex;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;
        }
        .profil-szint-badge {
          background: linear-gradient(135deg, #f9ab00, #ff6d00);
          color: white;
          font-size: 13px;
          font-weight: 700;
          padding: 6px 14px;
          border-radius: 50px;
          box-shadow: 0 4px 12px rgba(249,171,0,0.3);
          white-space: nowrap;
        }
        .profil-szint-bar {
          flex: 1;
          min-width: 100px;
          height: 10px;
          background: #f0f0f0;
          border-radius: 5px;
          overflow: hidden;
        }
        .profil-szint-bar-dolgo {
          height: 100%;
          background: linear-gradient(90deg, #f9ab00, #ff6d00);
          border-radius: 5px;
          transition: width 0.5s;
        }
        .profil-szint-xp {
          font-size: 12px;
          font-weight: 700;
          color: var(--text-muted);
          white-space: nowrap;
        }
        .profil-statok {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1rem;
        }
        .profil-stat {
          background: var(--bg-card);
          border-radius: 20px;
          padding: 1.5rem;
          text-align: center;
          box-shadow: 0 4px 16px rgba(0,0,0,0.06);
          border: 2px solid var(--border-color);
          transition: all 0.3s;
        }
        .profil-stat:hover { transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,0.1); }
        .profil-stat-ikon { font-size: 32px; margin-bottom: 8px; }
        .profil-stat-szam { font-size: 32px; font-weight: 900; margin-bottom: 4px; }
        .profil-stat-felirat { font-size: 13px; color: var(--text-muted); font-weight: 600; }
        .profil-szekció {
          background: var(--bg-card);
          border-radius: 24px;
          padding: 2rem;
          box-shadow: 0 4px 20px rgba(0,0,0,0.06);
          border: 2px solid var(--border-color);
        }
        .profil-szekció-cim {
          font-size: 20px;
          font-weight: 800;
          color: var(--text-primary);
          margin-bottom: 1.5rem;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .profil-jelvények {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
          gap: 1rem;
        }
        .profil-jelvény {
          background: var(--bg-card-alt);
          border-radius: 16px;
          padding: 1.25rem;
          text-align: center;
          border: 2px solid var(--border-color);
          transition: all 0.3s;
          opacity: 0.5;
          filter: grayscale(1);
        }
        .profil-jelvény.megszerzett {
          opacity: 1;
          filter: none;
          background: linear-gradient(135deg, #fff8e1, #fffde7);
          border-color: #f9ab00;
          box-shadow: 0 4px 16px rgba(249,171,0,0.2);
        }
        .profil-jelvény-ikon { font-size: 36px; margin-bottom: 8px; }
        .profil-jelvény-nev { font-size: 13px; font-weight: 700; color: var(--text-primary); margin-bottom: 4px; }
        .profil-jelvény-leiras { font-size: 11px; color: var(--text-muted); }
        .profil-gyerek-kartya {
          background: var(--bg-card-alt);
          border-radius: 20px;
          padding: 1.25rem;
          border: 2px solid var(--border-color);
          display: flex;
          align-items: center;
          gap: 1rem;
          flex-wrap: wrap;
          position: relative;
        }
        .profil-gyerek-avatar {
          width: 56px; height: 56px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 26px; flex-shrink: 0;
        }
        .profil-gyerek-nev { font-size: 16px; font-weight: 800; color: var(--text-primary); }
        .profil-gyerek-kor { font-size: 12px; font-weight: 700; color: var(--text-muted); }
        .profil-menu-gomb {
          margin-left: auto; width: 36px; height: 36px; border-radius: 50%;
          border: 2px solid var(--border-color-strong); background: var(--bg-card); font-size: 18px; font-weight: 900;
          color: #555; cursor: pointer; display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
        }
        .profil-menu-gomb:hover { background: #f0f0f0; }
        .profil-menu-lista {
          position: absolute; right: 0; top: calc(100% + 6px); z-index: 20;
          background: var(--bg-card); border-radius: 14px; border: 2px solid var(--border-color);
          box-shadow: 0 10px 28px rgba(0,0,0,0.15); overflow: hidden; min-width: 170px;
        }
        .profil-menu-elem {
          display: block; width: 100%; text-align: left; padding: 12px 16px;
          border: none; background: var(--bg-card); font-size: 14px; font-weight: 700;
          color: #333; cursor: pointer;
        }
        .profil-menu-elem:hover { background: var(--bg-card-alt); }
        .profil-menu-elem.veszelyes { color: #ea4335; border-top: 1px solid #f0f0f0; }
        .profil-tema-sor {
          display: flex; align-items: center; justify-content: space-between;
          padding: 14px 0; border-bottom: 1px solid #f0f0f0; margin-bottom: 1.25rem;
        }
        .profil-tema-kapcsolo {
          width: 52px; height: 28px; border-radius: 50px; border: none; cursor: pointer;
          position: relative; transition: background 0.2s;
        }
        .profil-tema-golyo {
          position: absolute; top: 3px; width: 22px; height: 22px; border-radius: 50%;
          background: white; transition: left 0.2s; box-shadow: 0 2px 6px rgba(0,0,0,0.2);
        }
        .profil-kijel-gomb {
          width: 100%;
          padding: 16px;
          background: #ffebee;
          border: 2px solid #ffcdd2;
          border-radius: 16px;
          font-size: 16px;
          font-weight: 700;
          color: #c62828;
          cursor: pointer;
          transition: all 0.3s;
        }
        .profil-kijel-gomb:hover { background: #ffcdd2; transform: translateY(-2px); }
        @keyframes jelvenyFelugrik { 0% { transform: scale(0.7); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }
        @keyframes jelvenyPulzal { 0%,100% { transform: scale(1); } 50% { transform: scale(1.1); } }
        @media (max-width: 768px) {
          .profil { padding: 2rem 1rem; }
          .profil-fejlec { padding: 1.5rem; gap: 1rem; }
          .profil-avatar { width: 80px; height: 80px; font-size: 36px; }
          .profil-nev { font-size: 22px; }
          .profil-statok { grid-template-columns: repeat(3, 1fr); gap: 0.75rem; }
          .profil-stat { padding: 1rem; }
          .profil-stat-szam { font-size: 24px; }
          .profil-stat-felirat { font-size: 11px; }
        }
        @media (max-width: 480px) {
          .profil-statok { grid-template-columns: repeat(3, 1fr); }
          .profil-jelvények { grid-template-columns: repeat(2, 1fr); }
          .profil-szekció { padding: 1.5rem; }
          .profil-szint-sor { flex-direction: column; align-items: flex-start; }
          .profil-szint-bar { width: 100%; }
        }
      `}</style>

      <div className="profil">
        <div className="profil-inner">
          {/* Fejléc — a szülő saját profilja, avatar-szerkesztés nélkül */}
          <div className="profil-fejlec">
            <div className="profil-avatar-keret">
              <div className="profil-avatar">
                {felhasznalo?.photoURL
                  ? <img src={felhasznalo.photoURL} alt="Profil" style={{width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover'}}/>
                  : '👤'}
              </div>
            </div>
            <div className="profil-info">
              <div className="profil-nev-sor">
                <div className="profil-nev">
                  {felhasznalo?.displayName || felhasznalo?.email?.split('@')[0] || 'NetOkos Szülő'}
                </div>
                <div className="profil-szulo-badge">👨‍👩‍👧 Szülő</div>
              </div>
              <div className="profil-email">{felhasznalo?.email}</div>
              {aktivGyerek && (
                <div className="profil-szint-sor">
                  <div className="profil-szint-badge">⭐ {szint}. szint</div>
                  <div className="profil-szint-bar">
                    <div className="profil-szint-bar-dolgo" style={{width: `${szintSzazalek}%`}}/>
                  </div>
                  <div className="profil-szint-xp">{xp} / {kovetkezoSzintXP} XP</div>
                </div>
              )}
            </div>
          </div>

          {/* Statisztikák */}
          <div className="profil-statok">
            <div className="profil-stat">
              <div className="profil-stat-ikon">⚡</div>
              <div className="profil-stat-szam" style={{color: '#f9ab00'}}>{xp}</div>
              <div className="profil-stat-felirat">Összes XP</div>
            </div>
            <div className="profil-stat">
              <div className="profil-stat-ikon">📚</div>
              <div className="profil-stat-szam" style={{color: '#1a73e8'}}>{teljesitettLeckek}</div>
              <div className="profil-stat-felirat">Teljesített lecke</div>
            </div>
            <div className="profil-stat">
              <div className="profil-stat-ikon">🏆</div>
              <div className="profil-stat-szam" style={{color: '#34a853'}}>{jelvények.filter(j => j.megszerzett).length}</div>
              <div className="profil-stat-felirat">Megszerzett jelvény</div>
            </div>
          </div>

          {/* Gyerek profilok */}
          <div className="profil-szekció">
            <div className="profil-szekció-cim">👨‍👩‍👧 Gyermekeid</div>

            {gyerekek.length === 0 && (
              <p style={{fontSize: '14px', color: 'var(--text-muted)', fontWeight: 600, marginBottom: '1.25rem'}}>
                Még nincs gyermek-profilod. Add hozzá az elsőt, hogy elkezdhesse a tanulást!
              </p>
            )}

            {gyerekek.map(gy => {
              const gyAvatar = gy.avatar || { szin1: '#1a73e8', szin2: '#9c27b0', ikon: '👶' };
              const menuNyitva = nyitottMenuGyerekId === gy.id;
              return (
                <div key={gy.id} style={{marginBottom: '1rem'}}>
                  <div className="profil-gyerek-kartya">
                    <div className="profil-gyerek-avatar" style={{background: `linear-gradient(135deg, ${gyAvatar.szin1}, ${gyAvatar.szin2})`}}>
                      {gyAvatar.ikon}
                    </div>
                    <div>
                      <div className="profil-gyerek-nev">{gy.nev}</div>
                      <div className="profil-gyerek-kor">{gy.koroszaly} év</div>
                    </div>

                    <button className="profil-menu-gomb" onClick={() => setNyitottMenuGyerekId(menuNyitva ? null : gy.id)} title="Több lehetőség">
                      ⋯
                    </button>
                    {menuNyitva && (
                      <div className="profil-menu-lista">
                        <button className="profil-menu-elem"
                          onClick={() => { setSzerkesztettGyerekId(szerkesztettGyerekId === gy.id ? null : gy.id); setNyitottMenuGyerekId(null); }}>
                          ✏️ Módosítás
                        </button>
                        <button className="profil-menu-elem veszelyes"
                          onClick={() => { setTorlesMegerosites(gy.id); setNyitottMenuGyerekId(null); }}>
                          🗑️ Törlés
                        </button>
                      </div>
                    )}
                  </div>

                  {torlesMegerosites === gy.id && (
                    <div style={{background: '#fce8e6', borderRadius: '18px', padding: '1.25rem', border: '2px solid #ea4335', marginTop: '0.75rem'}}>
                      <p style={{fontSize: '14px', fontWeight: 700, color: '#c62828', margin: '0 0 1rem', lineHeight: 1.6}}>
                        Biztosan véglegesen törlöd <strong>{gy.nev}</strong> profilját? Az összes haladása, XP-je és jelvénye elvész — ez nem vonható vissza!
                      </p>
                      <div style={{display: 'flex', gap: '10px'}}>
                        <button onClick={() => gyerekTorlese(gy.id)}
                          style={{padding: '10px 22px', borderRadius: '50px', border: 'none', fontSize: '13px', fontWeight: 800, color: 'white', cursor: 'pointer', background: '#ea4335'}}>
                          Igen, törlöm
                        </button>
                        <button onClick={() => setTorlesMegerosites(null)}
                          style={{padding: '10px 22px', borderRadius: '50px', border: '2px solid var(--border-color-strong)', fontSize: '13px', fontWeight: 800, color: 'var(--text-secondary)', cursor: 'pointer', background: 'var(--bg-card)'}}>
                          Mégse
                        </button>
                      </div>
                    </div>
                  )}

                  {szerkesztettGyerekId === gy.id && (
                    <div style={{marginTop: '0.75rem'}}>
                      <div style={{display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
                        <button
                          onClick={() => { setNevSzerkesztesGyerekId(nevSzerkesztesGyerekId === gy.id ? null : gy.id); setNevSzerkesztesErtek(gy.nev); }}
                          style={{padding: '8px 16px', borderRadius: '50px', border: '2px solid var(--border-color-strong)', background: 'var(--bg-card)', fontSize: '13px', fontWeight: 700, color: 'var(--text-secondary)', cursor: 'pointer'}}>
                          📝 Név módosítása
                        </button>
                        <button
                          onClick={() => setKarakterSzerkesztesGyerekId(karakterSzerkesztesGyerekId === gy.id ? null : gy.id)}
                          style={{padding: '8px 16px', borderRadius: '50px', border: '2px solid var(--border-color-strong)', background: 'var(--bg-card)', fontSize: '13px', fontWeight: 700, color: 'var(--text-secondary)', cursor: 'pointer'}}>
                          ✏️ Karakter
                        </button>
                        <button
                          onClick={() => setKoroszalyValtasGyerekId(koroszalyValtasGyerekId === gy.id ? null : gy.id)}
                          style={{padding: '8px 16px', borderRadius: '50px', border: '2px solid var(--border-color-strong)', background: 'var(--bg-card)', fontSize: '13px', fontWeight: 700, color: 'var(--text-secondary)', cursor: 'pointer'}}>
                          🎂 Korosztály váltása
                        </button>
                      </div>

                      {nevSzerkesztesGyerekId === gy.id && (
                        <div style={{background: 'var(--bg-card-alt)', borderRadius: '18px', padding: '1.25rem', border: '2px solid var(--border-color)', marginTop: '1rem'}}>
                          <label style={{fontSize: '13px', fontWeight: 700, color: 'var(--text-primary)', display: 'block', marginBottom: '8px'}}>
                            {gy.nev} új neve/beceneve
                          </label>
                          <div style={{display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center'}}>
                            <input type="text" value={nevSzerkesztesErtek} onChange={e => setNevSzerkesztesErtek(e.target.value)}
                              placeholder="pl. Kata"
                              style={{padding: '10px 14px', borderRadius: '10px', border: '1.5px solid #ddd', fontSize: '14px', outline: 'none'}} />
                            <button onClick={() => gyerekNevMentese(gy.id)} disabled={nevMentesFolyamatban || !nevSzerkesztesErtek.trim()}
                              style={{padding: '10px 22px', borderRadius: '50px', border: 'none', fontSize: '13px', fontWeight: 800, color: 'white', cursor: 'pointer', background: 'linear-gradient(135deg, #1a73e8, #4fc3f7)', opacity: nevMentesFolyamatban || !nevSzerkesztesErtek.trim() ? 0.6 : 1}}>
                              {nevMentesFolyamatban ? '⏳ Mentés...' : 'Mentés ✅'}
                            </button>
                            <button onClick={() => setNevSzerkesztesGyerekId(null)} disabled={nevMentesFolyamatban}
                              style={{padding: '10px 22px', borderRadius: '50px', border: '2px solid var(--border-color-strong)', fontSize: '13px', fontWeight: 800, color: 'var(--text-secondary)', cursor: 'pointer', background: 'var(--bg-card)'}}>
                              Mégse
                            </button>
                          </div>
                        </div>
                      )}

                      {karakterSzerkesztesGyerekId === gy.id && (
                        <AvatarSzerkeszto
                          avatar={gyAvatar}
                          onValtozas={(uj) => gyerekAvatarValtozas(gy.id, uj)}
                          onMentes={() => gyerekAvatarMentese(gy.id, gyAvatar)}
                          mentve={gyerekMentve}
                        />
                      )}

                      {koroszalyValtasGyerekId === gy.id && (
                        <div style={{background: 'var(--bg-card-alt)', borderRadius: '18px', padding: '1.25rem', border: '2px solid var(--border-color)', marginTop: '1rem'}}>
                          {!megerositendoKoroszaly && (
                            <>
                              <div style={{fontSize: '13px', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '10px'}}>
                                Válaszd ki az új korosztályt {gy.nev} számára:
                              </div>
                              <div style={{display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
                                {KOROSZTALYOK_VALTAS.map(k => (
                                  <button key={k.ertek} type="button"
                                    onClick={() => koroszalyValtasKezdemenyezese(gy.id, k.ertek, gy.koroszaly)}
                                    disabled={k.ertek === gy.koroszaly}
                                    style={{
                                      padding: '10px 18px', borderRadius: '10px', fontSize: '13px', fontWeight: 700,
                                      cursor: k.ertek === gy.koroszaly ? 'default' : 'pointer',
                                      border: k.ertek === gy.koroszaly ? '2px solid #1a73e8' : '1.5px solid #ddd',
                                      background: k.ertek === gy.koroszaly ? '#e3f2fd' : 'white',
                                      color: k.ertek === gy.koroszaly ? '#1a73e8' : '#555',
                                      opacity: k.ertek === gy.koroszaly ? 1 : 0.9,
                                    }}>
                                    {k.cimke}{k.ertek === gy.koroszaly ? ' (jelenlegi)' : ''}
                                  </button>
                                ))}
                              </div>
                            </>
                          )}

                          {megerositendoKoroszaly && megerositendoKoroszaly.gyerekId === gy.id && !jelszoBekero && (
                            <div>
                              <p style={{fontSize: '14px', fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 1rem'}}>
                                Biztosan {gy.nev} profilját a {KOROSZTALYOK_VALTAS.find(k => k.ertek === megerositendoKoroszaly.uj)?.cimke} korosztályba szeretnéd váltani?
                              </p>
                              {valtasHiba && <p style={{fontSize: '13px', color: '#ea4335', fontWeight: 700, marginBottom: '10px'}}>⚠️ {valtasHiba}</p>}
                              <div style={{display: 'flex', gap: '10px'}}>
                                <button onClick={koroszalyValtasMegerositese} disabled={valtasFolyamatban}
                                  style={{padding: '10px 22px', borderRadius: '50px', border: 'none', fontSize: '13px', fontWeight: 800, color: 'white', cursor: 'pointer', background: 'linear-gradient(135deg, #1a73e8, #4fc3f7)', opacity: valtasFolyamatban ? 0.6 : 1}}>
                                  {valtasFolyamatban ? '⏳ Ellenőrzés...' : 'Igen, váltás'}
                                </button>
                                <button onClick={koroszalyValtasMegse} disabled={valtasFolyamatban}
                                  style={{padding: '10px 22px', borderRadius: '50px', border: '2px solid var(--border-color-strong)', fontSize: '13px', fontWeight: 800, color: 'var(--text-secondary)', cursor: 'pointer', background: 'var(--bg-card)'}}>
                                  Mégse
                                </button>
                              </div>
                            </div>
                          )}

                          {megerositendoKoroszaly && megerositendoKoroszaly.gyerekId === gy.id && jelszoBekero && (
                            <div>
                              <p style={{fontSize: '14px', fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 10px'}}>
                                Add meg a fiókod jelszavát a megerősítéshez:
                              </p>
                              <div style={{display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center'}}>
                                <input type="password" value={jelszoMezo} onChange={e => setJelszoMezo(e.target.value)}
                                  placeholder="Jelszó"
                                  style={{padding: '10px 14px', borderRadius: '10px', border: '1.5px solid #ddd', fontSize: '14px', outline: 'none'}} />
                                <button onClick={jelszavasMegerositesKuldese} disabled={valtasFolyamatban || !jelszoMezo}
                                  style={{padding: '10px 22px', borderRadius: '50px', border: 'none', fontSize: '13px', fontWeight: 800, color: 'white', cursor: 'pointer', background: 'linear-gradient(135deg, #1a73e8, #4fc3f7)', opacity: valtasFolyamatban || !jelszoMezo ? 0.6 : 1}}>
                                  {valtasFolyamatban ? '⏳ Ellenőrzés...' : 'Megerősítés'}
                                </button>
                                <button onClick={koroszalyValtasMegse} disabled={valtasFolyamatban}
                                  style={{padding: '10px 22px', borderRadius: '50px', border: '2px solid var(--border-color-strong)', fontSize: '13px', fontWeight: 800, color: 'var(--text-secondary)', cursor: 'pointer', background: 'var(--bg-card)'}}>
                                  Mégse
                                </button>
                              </div>
                              {valtasHiba && <p style={{fontSize: '13px', color: '#ea4335', fontWeight: 700, marginTop: '10px'}}>⚠️ {valtasHiba}</p>}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}

            {/* Új gyermek hozzáadása */}
            {!ujGyerekFormaNyitva ? (
              <button onClick={() => setUjGyerekFormaNyitva(true)}
                style={{padding: '12px 24px', borderRadius: '50px', border: '2px dashed #1a73e8', background: 'var(--bg-card)', color: '#1a73e8', fontSize: '14px', fontWeight: 800, cursor: 'pointer'}}>
                + Új gyermek hozzáadása
              </button>
            ) : (
              <div style={{background: 'var(--bg-card-alt)', borderRadius: '18px', padding: '1.25rem', border: '2px solid var(--border-color)'}}>
                <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'flex-end'}}>
                  <div style={{flex: '1 1 200px'}}>
                    <label style={{fontSize: '13px', fontWeight: 700, color: 'var(--text-primary)', display: 'block', marginBottom: '6px'}}>Gyermeked neve</label>
                    <input type="text" value={ujGyerekNev} onChange={e => setUjGyerekNev(e.target.value)}
                      placeholder="pl. Kata"
                      style={{width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1.5px solid #ddd', fontSize: '14px', outline: 'none', boxSizing: 'border-box'}} />
                  </div>
                  <div style={{flex: '1 1 240px'}}>
                    <label style={{fontSize: '13px', fontWeight: 700, color: 'var(--text-primary)', display: 'block', marginBottom: '6px'}}>Korosztály</label>
                    <div style={{display: 'flex', gap: '8px'}}>
                      {KOROSZTALYOK_VALTAS.map(k => (
                        <button key={k.ertek} type="button" onClick={() => setUjGyerekKor(k.ertek)}
                          style={{
                            flex: 1, padding: '10px 6px', borderRadius: '10px', fontSize: '12px', fontWeight: 700, cursor: 'pointer',
                            border: ujGyerekKor === k.ertek ? '2px solid #1a73e8' : '1.5px solid #ddd',
                            background: ujGyerekKor === k.ertek ? '#e3f2fd' : 'white',
                            color: ujGyerekKor === k.ertek ? '#1a73e8' : '#555',
                          }}>
                          {k.cimke}
                        </button>
                      ))}
                    </div>
                  </div>
                  <button onClick={ujGyerekMentese} disabled={ujGyerekMentesFolyamatban || !ujGyerekNev.trim()}
                    style={{
                      padding: '11px 22px', borderRadius: '50px', border: 'none', fontSize: '14px', fontWeight: 800,
                      color: 'white', cursor: 'pointer', background: 'linear-gradient(135deg, #1a73e8, #4fc3f7)',
                      whiteSpace: 'nowrap', opacity: ujGyerekMentesFolyamatban || !ujGyerekNev.trim() ? 0.6 : 1,
                    }}>
                    {ujGyerekMentesFolyamatban ? '⏳ Mentés...' : 'Hozzáadás ✅'}
                  </button>
                  <button onClick={() => { setUjGyerekFormaNyitva(false); setUjGyerekNev(''); setUjGyerekKor('6-8'); }}
                    disabled={ujGyerekMentesFolyamatban}
                    style={{padding: '11px 18px', borderRadius: '50px', border: '2px solid var(--border-color-strong)', fontSize: '14px', fontWeight: 800, color: 'var(--text-secondary)', cursor: 'pointer', background: 'var(--bg-card)'}}>
                    Mégse
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Jelvények */}
          <div className="profil-szekció">
            <div className="profil-szekció-cim">
              🏅 Jelvények
            </div>
            <div className="profil-jelvények">
              {jelvények.map((j, i) => (
                <div key={i} className={`profil-jelvény ${j.megszerzett ? 'megszerzett' : ''}`}>
                  <div className="profil-jelvény-ikon">{j.ikon}</div>
                  <div className="profil-jelvény-nev">{j.nev}</div>
                  <div className="profil-jelvény-leiras">{j.leiras}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Fiók beállítások */}
          <div className="profil-szekció">
            <div className="profil-szekció-cim">⚙️ Fiók beállítások</div>

            <button
              className="profil-kijel-gomb"
              onClick={() => auth.signOut()}
              style={{marginBottom: '1.25rem'}}
            >
              🚪 Kijelentkezés
            </button>

            {!fiokTorlesNyitva ? (
              <button onClick={() => setFiokTorlesNyitva(true)}
                style={{width: '100%', padding: '14px', background: 'var(--bg-card)', border: '2px solid #ea4335', borderRadius: '16px', fontSize: '14px', fontWeight: 700, color: '#ea4335', cursor: 'pointer'}}>
                🗑️ Fiók végleges törlése
              </button>
            ) : (
              <div style={{background: '#fce8e6', borderRadius: '18px', padding: '1.5rem', border: '2px solid #ea4335'}}>
                <p style={{fontSize: '14px', fontWeight: 700, color: '#c62828', margin: '0 0 1.25rem', lineHeight: 1.6}}>
                  ⚠️ Ez a művelet <strong>véglegesen törli</strong> a fiókodat, az összes gyermek-profilodat és minden hozzájuk tartozó adatot (haladás, XP, jelvények). Ez a lépés <strong>nem vonható vissza</strong>.
                </p>

                {!fiokTorlesJelszoBekero && (
                  <div style={{display: 'flex', gap: '10px'}}>
                    <button onClick={fiokTorlesMegerositese} disabled={fiokTorlesFolyamatban}
                      style={{padding: '12px 24px', borderRadius: '50px', border: 'none', fontSize: '14px', fontWeight: 800, color: 'white', cursor: 'pointer', background: '#ea4335', opacity: fiokTorlesFolyamatban ? 0.6 : 1}}>
                      {fiokTorlesFolyamatban ? '⏳ Ellenőrzés...' : 'Igen, véglegesen törlöm'}
                    </button>
                    <button onClick={fiokTorlesMegse} disabled={fiokTorlesFolyamatban}
                      style={{padding: '12px 24px', borderRadius: '50px', border: '2px solid var(--border-color-strong)', fontSize: '14px', fontWeight: 800, color: 'var(--text-secondary)', cursor: 'pointer', background: 'var(--bg-card)'}}>
                      Mégse
                    </button>
                  </div>
                )}

                {fiokTorlesJelszoBekero && (
                  <div>
                    <p style={{fontSize: '14px', fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 10px'}}>
                      Add meg a fiókod jelszavát a végleges törléshez:
                    </p>
                    <div style={{display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center'}}>
                      <input type="password" value={fiokTorlesJelszo} onChange={e => setFiokTorlesJelszo(e.target.value)}
                        placeholder="Jelszó"
                        style={{padding: '10px 14px', borderRadius: '10px', border: '1.5px solid #ddd', fontSize: '14px', outline: 'none'}} />
                      <button onClick={fiokTorlesVegrehajtasaJelszoval} disabled={fiokTorlesFolyamatban || !fiokTorlesJelszo}
                        style={{padding: '10px 22px', borderRadius: '50px', border: 'none', fontSize: '13px', fontWeight: 800, color: 'white', cursor: 'pointer', background: '#ea4335', opacity: fiokTorlesFolyamatban || !fiokTorlesJelszo ? 0.6 : 1}}>
                        {fiokTorlesFolyamatban ? '⏳ Törlés...' : 'Végleges törlés'}
                      </button>
                      <button onClick={fiokTorlesMegse} disabled={fiokTorlesFolyamatban}
                        style={{padding: '10px 22px', borderRadius: '50px', border: '2px solid var(--border-color-strong)', fontSize: '13px', fontWeight: 800, color: 'var(--text-secondary)', cursor: 'pointer', background: 'var(--bg-card)'}}>
                        Mégse
                      </button>
                    </div>
                  </div>
                )}

                {fiokTorlesHiba && <p style={{fontSize: '13px', color: '#ea4335', fontWeight: 700, marginTop: '10px'}}>⚠️ {fiokTorlesHiba}</p>}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfilOldal;